// BlogList.js
import MahindraMe from '../assets/Me at Mahindra Worli Office 2.jpeg'

export const blogList = [
  {
    title: 'How My Internship at Mahindra & Mahindra Supercharged My Career',
    description: 'Explore what I learned during my internship at Mahindra Group, from technical skills to personal growth.',
    link: 'https://medium.com/@meetdheerajreddy/how-my-internship-at-mahindra-mahindra-supercharged-my-career-e268dce16f89',
    image: MahindraMe
  }
];
